import { getDefaultHeader, getFEClientName } from '../services/serviceAPIHelper';
import { getUserInformation } from './Login/loginService';
/**
 * Asigna el mercado seleccionado sacandolo del usuario actual o del state al request object.
 * 
 * @param {Object} requestObject 
 */
export function assignMarketToRequest(requestObject) {
    let user = getUserInformation();
    let useMarket = getFEClientName() === 'B2BWebOlympia';
    let selectedMarket = getMarketFromUserOrStorage({ currentUser: user });
    if (useMarket && selectedMarket && selectedMarket !== '') {
        requestObject.selectedMarket = { code: selectedMarket, label: selectedMarket };
    }
}

export function getFlagImage(code) {
    if (code === 'NT') {
        return 'https://via.placeholder.com/24x18&text=INT';
    }
    return `https://flagcdn.com/24x18/${String(code).toLowerCase()}.png`;
}

export function handleMarketChange(comp, market) {
    let state = comp.state;
    localStorage.setItem('ISOMarketCode', market.code);
    state.selectedMarket = market;
    comp.setState(state);
}

export function getMarketFromUserOrStorage(userHolder) {
    let ISOMarketCode = localStorage.getItem('ISOMarketCode');
    if (!ISOMarketCode) {
        ISOMarketCode = userHolder.currentUser && userHolder.currentUser.agency.ISODefaultMarket ? userHolder.currentUser.agency.ISODefaultMarket : '';
    }
    return ISOMarketCode;
}

export async function fetchMarkets(component, language) {
    let url = process.env.REACT_APP_API_URL + 'masterdata/countries?locale=' + language;
    let state = component.state;

    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        let data = await response.json();
        data = data.map(item => {
            return {
                code: item.code, label: item.label,
                icon: getFlagImage(item.code)
            };
        });
        state.markets = data;
        component.setState(state);
    }
    else {
        let error;
        try {
            error = await response.json();
        } catch (ee) {
            error = new Error('Unable to process request to: ' + url);
        }
        if (error) {
            alert(error);
            //throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/MarketAPI.js